const API_ROOT = "https://api.touchprop.com/api/v1";
const REFRESH_URL = `${API_ROOT}/myuser/token/refresh/`;
const LOGIN_PATH = "/login";
const DEFAULT_ERROR_MESSAGE =
  "\u062e\u0637\u0627 \u062f\u0631 \u0627\u0631\u062a\u0628\u0627\u0637 \u0628\u0627 \u0633\u0631\u0648\u0631. \u0644\u0637\u0641\u0627 \u062f\u0648\u0628\u0627\u0631\u0647 \u062a\u0644\u0627\u0634 \u06a9\u0646\u06cc\u062f.";
const API_ERROR_TRANSLATIONS = {
  "Direct crypto payment requires exactly one cart item.":
    "برای پرداخت رمزارزی باید دقیقاً یک مورد در سبد خرید وجود داشته باشد. موارد اضافی را حذف کنید یا اگر سبد خالی است، پلن را دوباره به سبد اضافه کنید.",
};

let refreshPromise = null;

const isFormData = (body) => typeof FormData !== "undefined" && body instanceof FormData;

const hasHeader = (headers, name) => {
  if (!headers) return false;
  const target = name.toLowerCase();
  return Object.keys(headers).some((key) => key.toLowerCase() === target);
};

const buildHeaders = (headers, token, body) => {
  const next = { ...(headers || {}) };
  if (token) next.Authorization = `Bearer ${token}`;
  if (!isFormData(body) && !hasHeader(next, "content-type")) {
    next["Content-Type"] = "application/json";
  }
  return next;
};

const readJson = async (res) => {
  try {
    return await res.json();
  } catch {
    return null;
  }
};

const extractMessage = (data, fallback) => {
  const message =
    data?.error || data?.detail || data?.message || fallback || DEFAULT_ERROR_MESSAGE;
  return API_ERROR_TRANSLATIONS[message] || message;
};

const isTokenError = (status, data) => {
  if (status === 401) return true;
  const code = data?.code || data?.error_code;
  if (code === "token_not_valid" || code === "TOKEN_NOT_VALID") return true;
  const detail = data?.detail || data?.error;
  return typeof detail === "string" && detail.toLowerCase().includes("token");
};

const clearAuthAndRedirect = () => {
  localStorage.removeItem("access_token");
  localStorage.removeItem("refresh_token");
  if (typeof window !== "undefined" && window.location.pathname !== LOGIN_PATH) {
    window.location.replace(LOGIN_PATH);
  }
};

const refreshAccessToken = async () => {
  if (refreshPromise) return refreshPromise;
  const refresh = localStorage.getItem("refresh_token");
  if (!refresh) return null;

  refreshPromise = fetch(REFRESH_URL, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ refresh }),
  })
    .then(async (res) => {
      const data = await readJson(res);
      if (!res.ok || !data?.access) return null;
      localStorage.setItem("access_token", data.access);
      return data.access;
    })
    .catch(() => null)
    .finally(() => {
      refreshPromise = null;
    });

  return refreshPromise;
};

export async function requestWithAuth(url, options = {}, config = {}) {
  const { fallbackMessage, retryOnAuth = true } = config;
  const access = localStorage.getItem("access_token");
  const headers = buildHeaders(options.headers, access, options.body);
  let response;

  try {
    response = await fetch(url, { ...options, headers });
  } catch (err) {
    const error = new Error(fallbackMessage || DEFAULT_ERROR_MESSAGE);
    error.cause = err;
    throw error;
  }

  const data = await readJson(response);
  if (response.ok) return data;

  if (retryOnAuth && isTokenError(response.status, data)) {
    const refreshed = await refreshAccessToken();
    if (refreshed) {
      const retryHeaders = buildHeaders(options.headers, refreshed, options.body);
      let retryResponse;
      try {
        retryResponse = await fetch(url, { ...options, headers: retryHeaders });
      } catch (err) {
        const error = new Error(fallbackMessage || DEFAULT_ERROR_MESSAGE);
        error.cause = err;
        throw error;
      }

      const retryData = await readJson(retryResponse);
      if (retryResponse.ok) return retryData;

      if (isTokenError(retryResponse.status, retryData)) {
        clearAuthAndRedirect();
        const error = new Error(DEFAULT_ERROR_MESSAGE);
        error.status = retryResponse.status;
        error.details = retryData;
        error.isAuthError = true;
        throw error;
      }

      const error = new Error(extractMessage(retryData, fallbackMessage));
      error.status = retryResponse.status;
      error.details = retryData;
      throw error;
    }

    clearAuthAndRedirect();
    const error = new Error(DEFAULT_ERROR_MESSAGE);
    error.status = response.status;
    error.details = data;
    error.isAuthError = true;
    throw error;
  }

  const error = new Error(extractMessage(data, fallbackMessage));
  error.status = response.status;
  error.details = data;
  if (isTokenError(response.status, data)) error.isAuthError = true;
  throw error;
}
